import { render, staticRenderFns } from "./QuestionnaireOtherExtensionEditor.vue?vue&type=template&id=0ece534f&scoped=true&"
import script from "./QuestionnaireOtherExtensionEditor.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireOtherExtensionEditor.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireOtherExtensionEditor.vue?vue&type=style&index=0&id=0ece534f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece534f",
  null
  
)

export default component.exports